import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WidgetUtils} from '../../widget.utils';
import {WidgetCheckboxV0NodeDto} from './models/widget-checkbox-v0-node.dto';

@Component({
  selector: 'pt-widget-checkbox-v0-form-item',
  template: `
    <div class="form-check checkbox-v0-form">
      <input class="form-check-input cursor-pointer"
             type="checkbox"
             [ngModel]="checkbox.checked"
             #radio
             (ngModelChange)="changeValue.emit($event)"
             id="{{id}}_{{checkbox.uuid}}">
      <div class="form-check-label" (click)='radio.click()'>
        <label class='cursor-pointer'>
          {{ checkbox.label }}
        </label>
        <pt-w-help (click)='$event.stopPropagation()' [help]='checkbox.help'></pt-w-help>
      </div>
    </div>
  `,
  styles: [`

    .checkbox-v0-form {
      position: relative;
      width: 100%;
      display: block;
      /*min-height: 30px;*/
      /*padding-left: 0px;*/

      min-height: 24px;
      padding: 2px 4px;
    }

    .checkbox-v0-form input {
      margin-top: 4px;
    }

    .form-check:hover {
      background: #D6E4FF !important;
    }

    .form-check-input {
      margin: 0;
    }

    .form-check-label {
      position: relative;
      width: 100%;
      /*display: flex;*/
      display: block;
      /*height: 37px;*/
      cursor: pointer;
      align-items: flex-start;
      padding-left: 20px;
    }

    .form-check-label label {
      /*height: 37px;*/
      margin: 0;
      display: inline;
      cursor: pointer;
      align-items: flex-start;
    }

  `]
})
export class WidgetCheckboxV0EditItemComponent {
  @Input() checkbox: WidgetCheckboxV0NodeDto;
  @Output() changeValue = new EventEmitter<boolean>();

  id = WidgetUtils.generateId('w_checkbox_');

}
